webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(14);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Game = undefined;
	
	var _stringify = __webpack_require__(1);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Game = exports.Game = function Game() {
	  var suits = ['♠', '♥', '♦', '♣'];
	  this.piles = this.deck = this.discard = {};
	
	  this.init = function () {
	    this.piles = [[], [], [], []];
	    this.deck = [];
	    this.discard = [];
	    this.initDeck();
	  };
	
	  var getVal = function getVal(i) {
	    i++;
	    switch (i) {
	      case 1:
	        return 'A';
	      case 11:
	        return 'J';
	      case 12:
	        return 'Q';
	      case 13:
	        return 'K';
	      default:
	        return i;
	    }
	  };
	  this.initDeck = function () {
	    for (var i = 0; i < 52; i++) {
	      var card = { suit: suits[Math.floor(i / 13)], face: getVal(i % 13) };
	      this.deck.push(card);
	    }
	    this.deck = shuffleArray(this.deck);
	  };
	  var shuffleArray = function shuffleArray(array) {
	    for (var i = array.length - 1; i > 0; i--) {
	      var j = Math.floor(Math.random() * (i + 1));
	      var temp = array[i];
	      array[i] = array[j];
	      array[j] = temp;
	    }
	    return array;
	  };
	
	  this.setFour = function () {
	    for (var i = 0; i < 4; i++) {
	      this.piles[i].push(this.deck.pop());
	    }
	  };
	
	  var faceToValue = function faceToValue(value) {
	    switch (value) {
	      case 'A':
	        return 14;
	      case 'K':
	        return 13;
	      case 'Q':
	        return 12;
	      case 'J':
	        return 11;
	      default:
	        return parseInt(value);
	    }
	  };
	
	  this.clearTops = function (piles, discard) {
	    if (typeof piles === 'undefined') {
	      piles = this.piles;
	    }
	    if (typeof discard === 'undefined') {
	      discard = this.discard;
	    }
	    var i = 0;
	    while (i < 4) {
	      var currPile = piles[i];
	      var currentTopCard = currPile[currPile.length - 1];
	      for (var j = i + 1; j < 4; j++) {
	        var focusPile = piles[j];
	        var focusTopCard = typeof focusPile[focusPile.length - 1] !== 'undefined' && focusPile[focusPile.length - 1];
	        if (!focusTopCard) {
	          continue;
	        }
	        if (!currentTopCard) {
	          continue;
	        }
	        if (currentTopCard.suit === focusTopCard.suit) {
	          if (faceToValue(currentTopCard.face) > faceToValue(focusTopCard.face)) {
	            var popped = piles[j].pop();
	          } else {
	            popped = piles[i].pop();
	          }
	          discard.push(popped);
	          i = -1;
	          j = 0;
	          break;
	        }
	      }
	      i++;
	    }
	    return { piles: piles, discard: discard };
	  };
	
	  this.mostDiscards = function () {
	    var options = [];
	    for (var i = 0; i < 4; i++) {
	      var pileCopy = JSON.parse((0, _stringify2.default)(this.piles));
	      if (pileCopy[i].length === 0) {
	        continue;
	      }
	
	      var movedCard = pileCopy[i][pileCopy[i].length - 1];
	      pileCopy = this.moveCard(movedCard, pileCopy);
	      var discard = [];
	      var results = this.clearTops(pileCopy, discard);
	
	      var j = 0;
	      while (this.emptyPile(pileCopy)) {
	        results = this.clearTops(pileCopy, discard);
	        pileCopy = results.piles;
	        discard = results.discard;
	        j++;
	        if (j > 5) {
	          break;
	        }
	      }
	      if (discard.length > 0) {
	        options.push({ card: movedCard, discard: discard });
	      }
	    }
	    options.sort(function (a, b) {
	      return a.discard.length < b.discard.length;
	    });
	    var bestOption = options[0];
	
	    return typeof bestOption !== 'undefined' && bestOption.card;
	  };
	
	  this.largestStart = function () {
	    var largestCard = false;
	    for (var i = 0; i < 4; i++) {
	      var pileCopy = JSON.parse((0, _stringify2.default)(this.piles));
	      if (pileCopy[i].length <= 1) {
	        continue;
	      }
	      var movedCard = pileCopy[i][pileCopy[i].length - 1];
	      if (!largestCard || faceToValue(movedCard.face) > faceToValue(largestCard.face)) {
	        largestCard = movedCard;
	      }
	    }
	    return largestCard;
	  };
	
	  this.decideMove = function () {
	    var bestOption = false;
	    bestOption = this.mostDiscards();
	    if (!bestOption) {
	      bestOption = this.largestStart();
	    }
	
	    return bestOption;
	  };
	
	  this.emptyPile = function (piles) {
	    if (typeof piles === 'undefined') {
	      piles = this.piles;
	    }
	    var emptyListLength = piles.filter(function (val) {
	      return val.length === 0;
	    }).length;
	    var stacked = false;
	    for (var i = 0; i < 4; i++) {
	      stacked = stacked || piles[i].length > 1;
	    }
	
	    return emptyListLength > 0 && stacked;
	  };
	
	  this.clearCard = function (card) {};
	
	  this.moveCard = function (card, piles) {
	    if (typeof piles === 'undefined') {
	      piles = this.piles;
	    }
	    if (!this.emptyPile(piles)) {
	      return false;
	    }
	    var popped = false;
	    for (var i = 0; i < piles.length; i++) {
	      var pile = piles[i];
	
	
	      var inspect = pile[pile.length - 1];
	      if (typeof inspect !== 'undefined' && popped === false && this.emptyPile(piles) && card.suit === inspect.suit && card.face === inspect.face) {
	        popped = piles[i].pop();
	        i = -1;
	        continue;
	      }
	      if (popped !== false && pile.length === 0) {
	        piles[i].push(popped);
	        break;
	      }
	    }
	    return piles;
	  };
	
	  this.doSomething = function () {
	    if (this.emptyPile()) {
	      var move = this.decideMove();
	      this.piles = this.moveCard(move);
	    } else {
	      this.setFour();
	    }
	  };
	
	  this.won = function () {
	    var singles = this.piles.filter(function (val) {
	      return val.length === 1;
	    });
	
	    return singles.length === 4;
	  };
	
	  this.init();
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Solitaire = __webpack_require__(16);
	
	var _Solitaire2 = _interopRequireDefault(_Solitaire);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Solitaire: _Solitaire2.default
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'Card',
	  props: ['card'],
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    moveCard: function moveCard(card) {
	      this.$parent.game.moveCard(card);
	    }
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(1);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _game = __webpack_require__(2);
	
	var _Card = __webpack_require__(15);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var game = new _game.Game();
	game.init();
	
	exports.default = {
	  components: {
	    Card: _Card2.default
	  },
	  name: 'Solitaire',
	  data: function data() {
	    return {
	      game: game
	    };
	  },
	
	  methods: {
	    setFour: function setFour() {
	      this.game.setFour();
	    },
	    clearTops: function clearTops() {
	      this.game.clearTops();
	    },
	    reset: function reset() {
	      this.game.init();
	    }
	  },
	  computed: {
	    emptyPile: function emptyPile() {
	      return this.game.emptyPile();
	    },
	    gameOver: function gameOver() {
	      return this.game.deck.length === 0 && !(this.game.deck.length === 0 && this.game.emptyPile());
	    },
	    disabled: function disabled() {
	      return this.game.emptyPile() || this.game.deck.length === 0 || !this.clearable;
	    },
	    clearable: function clearable() {
	      var pileCopy = JSON.parse((0, _stringify2.default)(this.game.piles));
	      var results = this.game.clearTops(pileCopy, []);
	      return !results.discard.length > 0;
	    }
	  }
	};

/***/ },
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = " <div id=app> <solitaire></solitaire> </div> ";

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = " <li class=\"list-group-item {{card.suit}}\" @click=moveCard(card) _v-13bc244e=\"\"> {{card.face}} {{card.suit}} </li> ";

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = " <div class=container _v-50cfb0c6=\"\"> <div class=row _v-50cfb0c6=\"\"> <button class=\"col-md-4 col-xs-4 btn btn-danger\" @click=reset _v-50cfb0c6=\"\">Reset</button> <button class=\"col-md-4 col-xs-4 btn btn-primary\" @click=setFour :disabled=disabled _v-50cfb0c6=\"\"> {{gameOver ? 'Good Game!' : !clearable ? 'Not Cleared Yet' : disabled ? 'Fill the Empty' : 'Draw Four Cards'}} </button> <button class=\"col-md-4 col-xs-4 btn btn-success\" @click=clearTops :disabled=clearable _v-50cfb0c6=\"\">Clear Tops</button> </div> <div class=row _v-50cfb0c6=\"\"> <div class=\"col-md-2 col-xs-2 deck bg-success\" _v-50cfb0c6=\"\"> <h1 _v-50cfb0c6=\"\">Deck</h1> <ul class=list-group _v-50cfb0c6=\"\"> <card v-for=\"card in game.deck\" :card=card _v-50cfb0c6=\"\"></card> </ul> </div> <div class=\"col-md-8 col-xs-8 bg-info\" _v-50cfb0c6=\"\"> <h1 _v-50cfb0c6=\"\"> Game</h1> <div class=\"col-md-3 col-xs-3 pile bg-default\" v-for=\"pile in game.piles\" _v-50cfb0c6=\"\"> <ul class=list-group _v-50cfb0c6=\"\"> <card v-for=\"card in pile\" :card=card _v-50cfb0c6=\"\"></card> </ul> </div> </div> <div class=\"col-md-2 col-xs-2 discard bg-danger\" _v-50cfb0c6=\"\"> <h1 _v-50cfb0c6=\"\">Trash</h1> <ul class=list-group _v-50cfb0c6=\"\"> <card v-for=\"card in game.discard\" :card=card _v-50cfb0c6=\"\"></card> </ul> </div> </div> </div> ";

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(8)
	__vue_script__ = __webpack_require__(3)
	__vue_template__ = __webpack_require__(11)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(9)
	__vue_script__ = __webpack_require__(4)
	__vue_template__ = __webpack_require__(12)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(10)
	__vue_script__ = __webpack_require__(5)
	__vue_template__ = __webpack_require__(13)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.1f9e147fe8a3776cf726.js
 **/